import { render, staticRenderFns } from "./VillagesSummary.vue?vue&type=template&id=03322ad8&scoped=true&"
import script from "./VillagesSummary.vue?vue&type=script&lang=js&"
export * from "./VillagesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03322ad8",
  null
  
)

export default component.exports